module.exports = __webpack_public_path__ + "img/guanyuwomen.6b6140b2.png";